import { useMutation } from '@apollo/client';
import { DELETE_CREATIVE } from '../../graphql/mutations/creativeMutations';

/**
 * Hook to delete a Creative profile
 * @returns {object} - { handleDeleteCreative, loading, error }
 */
export const useDeleteCreative = () => {
  const [deleteCreativeMutation, { loading, error }] = useMutation(DELETE_CREATIVE, {
    refetchQueries: ['CreativesByUserID', 'GetCreative'],
    awaitRefetchQueries: true
  });

  const sanitizeInput = (input = {}) => {
    const cleaned = { ...input };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === undefined) {
        delete cleaned[key];
      }
    });
    return cleaned;
  };

  const handleDeleteCreative = async (creativeData) => {
    try {
      if (!creativeData?.id) {
        throw new Error('Das Creative-Profil konnte nicht zugeordnet werden. Bitte lade die Seite neu und versuche es erneut.');
      }

      const input = sanitizeInput({
        id: creativeData.id
      });

      const variables = sanitizeInput({
        input,
        condition: creativeData?.condition
      });

      const { data: creativeResponse } = await deleteCreativeMutation({
        variables
      });

      return creativeResponse?.deleteCreative;
    } catch (error) {
      console.error('Error deleting creative:', error);
      throw error;
    }
  };

  return {
    handleDeleteCreative,
    loading,
    error
  };
};
